export const AUTH_TRANSLATION_NAMESPACE = 'auth'
